import { isBefore, isFuture, isToday } from 'date-fns';
import { removeAccents, normalizeLastName } from '@/utils';
import { i18n } from '@/i18n';
const { DateTime } = require('luxon');
// eslint-disable-next-line no-unused-vars
export const formRules = {
    methods: {
        getFormRule(rule, textKey = null) {
            return {
                name: v => /^[a-záàâäãåçéèêëíìîïñóòôöõúùûüýÿæœ._ '-s]+$/i.test(v.trim()) || i18n.t('base.errors.invalidName'),
                comment: v => /^[a-záàâäãåçéèêëíìîïñóòôöõúùûüýÿæœ!"\r\n '-s]+$/i.test(v.trim()) || i18n.t('base.errors.invalidComment'),
                nam: v => /^[A-Z]{4}\s\d{4}\s\d{2}[A-HJ-NP-Z1-9]\d$/g.test(v) || i18n.t('base.errors.invalidNam'),
                pastDate: v => (!isBefore(Date.now(), v) && /^(20|19)[0-9][0-9]-?(0[1-9]|1[0-2])-?(0[1-9]|[12][0-9]|3[01])$/.test(v)) || i18n.t(textKey || 'base.errors.invalidDate'),
                futureDate: v => ((isFuture(v) || isToday(v)) && /^20[23][0-9]-?(0[1-9]|1[0-2])-?(0[1-9]|[12][0-9]|3[01])$/.test(v)) || i18n.t(textKey || 'base.errors.invalidDate'),
                // Email validation rule
                // eslint-disable-next-line no-useless-escape
                email: v => /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(v) ||
                    i18n.t(textKey || 'base.errors.invalidEmail'),
                // Telephone validation (Required)
                telephone: v => (v && v.length === 10) || i18n.t(textKey || 'base.errors.phone2short'),
                // Cellphone validation (Not required)
                cellphone: v => v ? v.length === 10 || i18n.t(textKey || 'base.errors.phone2short') : true || i18n.t(textKey || 'base.errors.phone2short'),
                // Telephone validation (Required)
                telephone2: v => /^\(\d{3}\)\s\d{3}\s-\s\d{4}$/.test(v) || i18n.t('base.errors.phone2short'),
                validateNamAgainstNameAndBirthday: (nam, otherMetadata = []) => {
                    const [firstName, lastName, birthday] = otherMetadata;
                    const initialPartRegex = firstName ? removeAccents(firstName[0]) : '[A-Z]';
                    const namePartRegex = lastName ? normalizeLastName(lastName).slice(0, 3) : '[A-Z]{3}';
                    const formattedBirthday = birthday ? birthday.replace(/[^0-9]/gi, '').slice(0, 8) : '';
                    // Added + 50 to month number for female NAM
                    const birthdayPartRegex = formattedBirthday ? `${formattedBirthday.slice(2, 4)}[${formattedBirthday[4] + (parseInt(formattedBirthday[4]) + 5)}]${formattedBirthday.slice(5, 8)}` : '[0-9]{2}[0156][0-9]{3}';
                    const regex = new RegExp(`(${namePartRegex.toUpperCase() + initialPartRegex.toUpperCase() + birthdayPartRegex})[A-HJ-NP-Z1-9]\\d$`, 'gi');

                    return regex.test(nam.replace(/\s/g, '')) || i18n.t('base.errors.invalidNam');
                },
                // isTemporaryNam: v => !isTemporaryNam(v) || i18n.t('base.errors.TemporaryNam'),
                isNotTemporaryNAM: v => !/^.{10}M.{1}$/.test(v.replace(/\s+/gi, '')) || i18n.t('base.errors.temporaryNAM'),
                url: v => /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(v) || i18n.t(textKey || 'base.errors.invalidUrl'),
                zipCodeCa: v => /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/.test(v) || i18n.t(textKey || 'base.errors.invalidZipCode'),
                validMonth: v => {
                    return (+v >= 1 && +v <= 12) || i18n.t(textKey || 'base.errors.invalidMonth');
                },
                validDate: v => formRules.methods.getFormRule('validDate_OR')(v) || i18n.t(textKey || 'base.errors.invalidDate'),
                validDate_OR: v => {
                    // yyyy/mm/dd
                    if (!v) return true;
                    const regex = v.length === 8 ? /(\d{4})(\d{2})(\d{2})/ : /(\d{4})[-](\d{2})[-](\d{2})/;
                    const parts = regex.exec(v);
                    if (parts) {
                        let date = new Date((+parts[1]), (+parts[2]) - 1, (+parts[3]));
                        if ((date.getDate() === parseInt(parts[3])) &&
                            (date.getMonth() === parseInt(parts[2]) - 1) &&
                            (date.getFullYear() === parseInt(parts[1]))) {
                            return true;
                        }
                    }
                    return false;
                },
                confirmationCode: v => /^[a-zA-Z0-9]{8}$/.test(v) || i18n.t('base.errors.invalidConfirmationCode'),
                employeeNumber: v => /^[0-9a-zA-Z]{1,10}$/.test(v) || i18n.t('base.errors.invalidEmployeeNumber'),
                validateFormResponse: v => v === 0 || v === 1 || v === -1 || i18n.t('base.errors.formQuestion'),
                validateDateIsInRange: (selectedDate, maxSelectableDate, minSelectableDate) => {
                    const maxDate = DateTime.fromISO(maxSelectableDate);
                    const minDate = DateTime.fromISO(minSelectableDate);
                    const selected = DateTime.fromISO(selectedDate);

                    return (selected >= minDate && selected <= maxDate) || i18n.t(textKey || 'base.errors.invalidDateRange', { minDate: minDate.toFormat('yyyy-MM-dd'), maxDate: maxDate.toFormat('yyyy-MM-dd') });
                },
            }[rule];
        },
        requiredField(textKey = null) {
            return v => (v && !!v && !!v.toString().trim()) || i18n.t(textKey || 'base.errors.requiredField');
        },
    },
};
